import { SMTFoodEntryData } from '@equip.health/ui';
import { isEmpty } from 'lodash';

import {
  CreateSMTMealRequest,
  UpdateSMTEntryRequest,
} from '~/store/services/SMT';
import { SMTMealType } from '~/components/maud/patients/profile/smt/types';

/**
 * Transforms an SMT entry to SMTFoodEntryData format for the modal
 * @param entry - The SMT entry to transform
 * @returns SMTFoodEntryData ready for the modal
 */
export const transformSMTEntryToFoodEntryData = (
  entry: SMTEntry,
): SMTFoodEntryData => {
  // Map entryType to mealType if mealType is not already set
  const mealType = entry.mealType ?? SMTMealType.Meal;

  // Transform the first image from the images array if available
  const image = isEmpty(entry.images)
    ? undefined
    : {
        imageUrl: entry.images[0].url,
        name: entry.images[0].fileName,
      };

  return {
    calories: entry.calories ?? undefined,
    comment: entry.comment ?? '',
    description: entry.description ?? '',
    image,
    isNewFood: entry.isNewFood ?? false,
    mealType: mealType as SMTMealType,
    occurredAt: entry.occurredAt,
  };
};

/**
 * Transforms SMTFoodEntryData to CreateSMTMealRequest format for API calls
 * @param data - SMTFoodEntryData from the form
 * @param patientId - The patient ID
 * @returns CreateSMTMealRequest ready for API
 */
export const transformFoodEntryDataToCreateRequest = (
  data: SMTFoodEntryData,
  patientId: string,
): CreateSMTMealRequest => {
  return {
    calories: data.calories,
    comment: data.comment || '',
    description: data.description,
    isNewFood: data.isNewFood ?? false,
    mealType: data.mealType as SMTMealType,
    occurredAt: data.occurredAt,
    patientId,
  };
};

/**
 * Transforms SMTFoodEntryData to UpdateSMTEntryRequest format for API calls
 * @param data - SMTFoodEntryData from the form
 * @param smtEntryId - The SMT entry ID to update
 * @param patientId - The patient ID
 * @returns UpdateSMTEntryRequest ready for API
 */
export const transformFoodEntryDataToUpdateRequest = (
  data: SMTFoodEntryData,
  smtEntryId: string,
  patientId: string,
): UpdateSMTEntryRequest => {
  return {
    calories: data.calories,
    comment: data.comment || '',
    description: data.description,
    isNewFood: data.isNewFood ?? false,
    mealType: data.mealType as SMTMealType,
    occurredAt: data.occurredAt,
    patientId,
    smtEntryId,
  };
};
